// extracted by mini-css-extract-plugin
module.exports = {"pt-notes-dialog":"pt-notes-dialog-73dc4e997cd5ec2a2f947b988523f921"};